export const COLUMNS = 16;
export const ROWS = 12;
export const DIRECTIONS = { right: { x: 1, y: 0 }, down: { x: 0, y: 1 }, left: { x: -1, y: 0 }, up: { x: 0, y: -1 } };
const order = ['right', 'down', 'left', 'up'];
const same = (a, b) => a.x === b.x && a.y === b.y;
const inside = p => p.x >= 0 && p.x < COLUMNS && p.y >= 0 && p.y < ROWS;

function foodFor(snake, random) {
  const free = [];
  for (let y = 0; y < ROWS; y += 1) for (let x = 0; x < COLUMNS; x += 1) {
    if (!snake.some(p => same(p, { x, y }))) free.push({ x, y });
  }
  return free[Math.min(free.length - 1, Math.floor(random() * free.length))] || null;
}

export function createSnake(random = Math.random) {
  const snake = [{ x: 7, y: 6 }, { x: 6, y: 6 }, { x: 5, y: 6 }];
  return { snake, direction: 'right', food: foodFor(snake, random), score: 0, ended: false };
}

export function turnSnake(state, direction) {
  if (!DIRECTIONS[direction]) return state;
  const a = DIRECTIONS[state.direction], b = DIRECTIONS[direction];
  return a.x + b.x === 0 && a.y + b.y === 0 ? state : { ...state, direction };
}

export function stepSnake(state, random = Math.random) {
  if (state.ended) return state;
  const head = state.snake[0];
  const move = direction => ({ x: head.x + DIRECTIONS[direction].x, y: head.y + DIRECTIONS[direction].y });
  let direction = state.direction;
  let next = move(direction);
  if (!inside(next)) {
    // Turn along the wall instead of ending a run at the first edge.
    const index = order.indexOf(direction);
    direction = [order[(index + 1) % 4], order[(index + 3) % 4]]
      .find(candidate => inside(move(candidate)) && !state.snake.slice(0, -1).some(p => same(p, move(candidate)))) || direction;
    next = move(direction);
  }
  const eating = state.food && same(next, state.food);
  const body = eating ? state.snake : state.snake.slice(0, -1);
  if (!inside(next) || body.some(p => same(p, next))) return { ...state, ended: true };
  const snake = [next, ...state.snake];
  if (!eating) snake.pop();
  const food = eating ? foodFor(snake, random) : state.food;
  return { ...state, snake, direction, food, score: state.score + (eating ? 1 : 0), ended: !food };
}
